export function reasonText(t, r) {
    let s = t(`sched.reasons.${r.code}`);
    if (s === `sched.reasons.${r.code}`) s = r.message || r.code;
    return s.replace(/\{(\w+)\}/g, (_, k) => (r[k] ?? ""));
}

export function reasonsFromError(err) {
    const d = err?.response?.data?.detail;
    if (!d || typeof d !== "object") return { conflicts: [], warnings: [] };
    return { conflicts: d.conflicts || (d.code && d.code !== "warnings" ? [{ code: d.code, message: d.message }] : []), warnings: d.warnings || [] };
}

export const fmtTime = (iso) => { const d = new Date(iso); return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; };

export const eur = (n) => `€${Number(n || 0).toFixed(2)}`;
